import { addKeysAsField } from "../utils/misc"

export class PianoRoller {
    static parametersDescription = addKeysAsField({
        pianoRollColorCode: {type: 'enum', options: ['melodic', 'harmonic', 'none'], initial: 'melodic', local: true},
    }, "nom");
}
